import { useState } from "react";
import { Row, Col, Input } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import Back from "../../../assets/images/backIcon.svg";
import CustomerSearch from "../../../assets/images/c-serach.svg";
import Cancel from "../../../assets/images/cancel-new.svg";
import Retrieve from "../../../assets/images/retrieve.png";

const ParkedBillView = ({
  themeJSON,
  pricePrecision,
  parkedBillRef,
  parkedBillSearchInput,
  onChangeParkedBill,
  searchParkedBill,
  setIsparkedBill,
  setIsInputFocused,
  setParkedBillSearchInput,
  setLayoutName,
  setInputName,
  setOpen,
  keyboard,
  filterdParkedList,
  selectedKeys,
  expandedRowKeys,
  handleExpandPerkedData,
  setTableValue,
  retrieveParkedData,
  upsertPOSLog,
  cart,
  setParkedBill,
  discardMessage,
  columns,
  tillData,
  colorVariable,
}) => {
  const [expandedRowKey, setExpandedRowKey] = useState(null);

  const toggleExpand = (key) => {
    setExpandedRowKey(expandedRowKey === key ? null : key);
  };

  return (
    <div
      style={{
        background: colorVariable ? colorVariable : "#f3f4f9",
        height: "100vh",
      }}
    >
      <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
        <Col
          span={6}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.8vw",
          }}
        >
          <img
            src={Back}
            id="sm-parked-bill-back"
            onClick={() => {
              setIsparkedBill(false);
              setIsInputFocused(false);
              setParkedBillSearchInput("");
              setLayoutName("default");
            }}
            style={{
              height: "2.2vw",
              cursor: "pointer",
            }}
          />
          <span
            style={{
              fontSize: "1.8em",
              fontWeight: 500,
              color: "#0F0718",
              lineHeight: 1,
            }}
          >
            Parked Bills
          </span>
        </Col>
        <Col
          span={18}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Input
            placeholder="Search for customers"
            ref={parkedBillRef}
            prefix={<img src={CustomerSearch} style={{ width: "1.5em", margin: "0.75em" }} alt="" />}
            allowClear={false}
            style={{ width: "70%", borderRadius: "5px", border: "none" }}
            onPressEnter={() => {
              searchParkedBill(parkedBillSearchInput);
            }}
            onChange={(e) => {
              onChangeParkedBill(e.target.value);
              keyboard?.current?.setInput(e.target.value);
            }}
            id="sm-parked-bill-customer"
            onFocus={() => {
              setTimeout(() => {
                setInputName("parkedBill");
                setOpen(true);
                keyboard?.current?.setInput(parkedBillSearchInput);
              }, 300);
            }}
            onBlur={() => {
              setIsInputFocused(false);
            }}
            value={parkedBillSearchInput}
            className="parkedCustomer-sm"
          />
        </Col>
      </Row>

      <Row style={{ padding: "1em 1.5em" }}>
        <div style={{ width: "100%" }}>
          {filterdParkedList?.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "3rem",
                color: "#929098",
                background: "#fff",
                borderRadius: "12px",
              }}
            >
              No parked bills found
            </div>
          ) : (
            <div>
              <Row
                style={{
                  background: "#fff",
                  padding: "1rem 1.5rem",
                  borderRadius: "12px 12px 0 0",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  color: "#5D5A66",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <Col span={6}>Parked Sale</Col>
                <Col span={5}>Document No</Col>
                <Col span={6}>Customer</Col>
                <Col span={3}>Qty</Col>
                <Col span={4}>Status</Col>
              </Row>

              {filterdParkedList?.map((record) => (
                <div key={record.key}>
                  <Row
                    style={{
                      background: "#fff",
                      padding: "1rem 1.5rem",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                      alignItems: "center",
                      fontSize: "0.95rem",
                    }}
                    onClick={() => toggleExpand(record.key)}
                  >
                    <Col span={6}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        {expandedRowKey === record.key ? (
                          <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                        ) : (
                          <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                        )}
                        <span>{record.parkedTime || record.title}</span>
                      </div>
                    </Col>
                    <Col span={5}>
                      <span style={{ fontWeight: 500 }}>{record.parkedCart?.documentno || "-"}</span>
                    </Col>
                    <Col span={6}>{record.customer || record.parkedCart?.customer?.name || "Cash & Carry"}</Col>
                    <Col span={3}>{record.parkedCart?.totalQty || record.parkedCart?.items?.length || 0}</Col>
                    <Col span={4}>
                      <span
                        style={{
                          padding: "0.25rem 0.75rem",
                          borderRadius: "6px",
                          fontSize: "0.85rem",
                          fontWeight: 500,
                          background: "#fff4e6",
                          color: "#fa8c16",
                        }}
                      >
                        Parked
                      </span>
                    </Col>
                  </Row>

                  {expandedRowKey === record.key && (
                    <div
                      style={{
                        background: "#fafafa",
                        padding: "1.5rem",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "8px",
                          padding: "1rem",
                          marginBottom: "1rem",
                        }}
                      >
                        <Row
                          style={{
                            fontWeight: 600,
                            fontSize: "0.85rem",
                            color: "#5D5A66",
                            padding: "0.5rem 0",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          <Col span={10}>Description</Col>
                          <Col span={4} style={{ textAlign: "center" }}>
                            Qty
                          </Col>
                          <Col span={5} style={{ textAlign: "right" }}>
                            Unit Price
                          </Col>
                          <Col span={5} style={{ textAlign: "right" }}>
                            Net Total
                          </Col>
                        </Row>

                        {record.parkedCart?.items?.map((item, index) => (
                          <Row
                            key={item.lineId || index}
                            style={{
                              padding: "0.75rem 0",
                              borderBottom: index < record.parkedCart.items.length - 1 ? "1px solid #f5f5f5" : "none",
                              fontSize: "0.9rem",
                            }}
                          >
                            <Col span={10}>
                              <div>{item.name || item.value}</div>
                              {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                            </Col>
                            <Col span={4} style={{ textAlign: "center" }}>
                              {item.weight}
                            </Col>
                            <Col span={5} style={{ textAlign: "right" }}>
                              {(item.realPrice || item.unitPrice)?.toFixed?.(pricePrecision) ?? item.realPrice}
                            </Col>
                            <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                              {item.nettotal?.toFixed?.(pricePrecision) ?? item.nettotal}
                            </Col>
                          </Row>
                        ))}
                      </div>

                      <Row>
                        <Col span={14}></Col>
                        <Col span={10}>
                          <div
                            style={{
                              background: "#fff",
                              borderRadius: "8px",
                              padding: "1rem",
                            }}
                          >
                            <Row style={{ marginBottom: "0.5rem", fontSize: "0.9rem" }}>
                              <Col span={12}>Subtotal</Col>
                              <Col span={12} style={{ textAlign: "right" }}>
                                {(record.parkedCart.total - record.parkedCart.tax).toFixed(pricePrecision)}
                              </Col>
                            </Row>
                            <Row
                              style={{
                                marginBottom: "0.75rem",
                                fontSize: "0.9rem",
                                paddingBottom: "0.75rem",
                                borderBottom: "1px solid #f0f0f0",
                              }}
                            >
                              <Col span={12}>Total tax</Col>
                              <Col span={12} style={{ textAlign: "right" }}>
                                {record.parkedCart.tax?.toFixed(pricePrecision)}
                              </Col>
                            </Row>
                            <Row style={{ fontWeight: 600, fontSize: "1rem" }}>
                              <Col span={12}>SALE TOTAL</Col>
                              <Col span={12} style={{ textAlign: "right" }}>
                                {record.parkedCart.total?.toFixed(pricePrecision)}
                              </Col>
                            </Row>
                          </div>

                          <button
                            onClick={() => {
                              setTableValue("POS");
                              setIsparkedBill(false);
                              retrieveParkedData(record);
                              upsertPOSLog(cart, "OPK", "Retrieved");
                            }}
                            id="sm-parked-bill-retrieve"
                            style={{
                              width: "100%",
                              marginTop: "1rem",
                              padding: "0.75rem",
                              background: "#1890ff",
                              color: "#fff",
                              border: "none",
                              borderRadius: "8px",
                              fontSize: "0.95rem",
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                          >
                            <img src={Retrieve} style={{ height: "1em", paddingRight: "0.4em", verticalAlign: "middle" }} />
                            Retrieve sale
                          </button>

                          <button
                            onClick={() => {
                              setParkedBill(record);
                              discardMessage("Discard Sale", "Are you sure you want to discard the sale!", record);
                            }}
                            id="sm-parked-bill-discard"
                            style={{
                              width: "100%",
                              marginTop: "0.5rem",
                              padding: "0.75rem",
                              background: "#fff",
                              color: "#ff4d4f",
                              border: "1px solid #ff4d4f",
                              borderRadius: "8px",
                              fontSize: "0.95rem",
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                          >
                            <img src={Cancel} style={{ height: "1em", paddingRight: "0.4em", verticalAlign: "middle" }} />
                            Discard sale
                          </button>
                        </Col>
                      </Row>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </Row>
    </div>
  );
};

export default ParkedBillView;
